// ─────────────────────────────────────────────────────────
// lib/queryKeys.ts — TanStack Query key factory
//
// Centralised key definitions eliminate magic strings and
// ensure invalidation targets the right cache entries.
//
// Usage:
//   useQuery({ queryKey: QUERY_KEYS.companyData(companyId) })
//   queryClient.invalidateQueries({ queryKey: QUERY_KEYS.all })
// ─────────────────────────────────────────────────────────

export const QUERY_KEYS = {
  /** Root key — invalidating this clears ALL cached data */
  all: ['civilbilldesk'] as const,

  /** Full company data load (all 23+ collections in one fetch) */
  companyData: (companyId: string) =>
    ['civilbilldesk', 'company', companyId, 'data'] as const,

  /** Individual collection slices — used for targeted invalidation */
  collection: (companyId: string, col: string) =>
    ['civilbilldesk', 'company', companyId, col] as const,

  /** Company profile / brand doc */
  brand: (companyId: string) =>
    ['civilbilldesk', 'company', companyId, 'brand'] as const,

  /** Supabase user profile */
  userProfile: (uid: string) =>
    ['civilbilldesk', 'user', uid] as const,

  /** Platform admin — all companies */
  allCompanies: () =>
    ['civilbilldesk', 'admin', 'companies'] as const,

  /** Platform stats */
  platformStats: () =>
    ['civilbilldesk', 'admin', 'stats'] as const,
} as const
